import { post } from '@va/http-client';

export const sendReview = (websiteId, data) => {
  const url = `/websites/${websiteId}/review`;

  return post(url, {}, data);
};
